<template>
  <div style="height: 100%;margin: 0 20px">
    <div style="height: calc(100% - 10px);">
      <el-row style="height: 100%;">
        <el-col :span="8" class="col-list">
          <div style="height: 33.3%">
            <el-row style="height: 100%;">
              <el-col :span="12" class="col-list">
                <div style="height: 50px" v-if="bigScreen"></div>
                <div style="height: 30px" v-else></div>
                <div class="box-item">
                  <div style="height: 1px"></div>
                  <div :class="bigScreen ? 'box-title-big' : 'box-title'">
                    <span>服务人数</span>
                  </div>
                  <div :class="bigScreen ? 'box-main-big' : 'box-main'">
                    <index-number-service ref="numberService" v-if="isFamily" :ServicesCountWithTime="ServicesCountWithTime"></index-number-service>
                  </div>
                </div>
              </el-col>
              <el-col :span="12" class="col-list">
                <div style="height: 50px" v-if="bigScreen"></div>
                <div style="height: 30px" v-else></div>
                <div class="box-item">
                  <div style="height: 1px"></div>
                  <div :class="bigScreen ? 'box-title-big1' : 'box-title1'">
                    <span>家庭&设备总数</span>
                  </div>
                  <div :class="bigScreen ? 'box-main-big' : 'box-main'">
                    <index-family-device ref="familyDevice" v-if="isFamily" :familyDevice="familyDevice"></index-family-device>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
          <div style="height: 33.3%">
            <el-row style="height: 100%;">
              <el-col :span="12" class="col-list">
                <div style="height: 50px" v-if="bigScreen"></div>
                <div style="height: 30px" v-else></div>
                <div class="box-item">
                  <div style="height: 1px"></div>
                  <div :class="bigScreen ? 'box-title-big1' : 'box-title1'">
                    <span>派单&完成数量</span>
                  </div>
                  <div :class="bigScreen ? 'box-main-big' : 'box-main'">
                    <index-send-order ref="indexsendorder"></index-send-order>
                  </div>
                </div>
              </el-col>
              <el-col :span="12" class="col-list">
                <div style="height: 50px" v-if="bigScreen"></div>
                <div style="height: 30px" v-else></div>
                <div class="box-item">
                  <div style="height: 1px"></div>
                  <div :class="bigScreen ? 'box-title-big1' : 'box-title1'">
                    <span>今日派单次数</span>
                  </div>
                  <div :class="bigScreen ? 'box-main-big' : 'box-main'">
                    <index-send-orders ref="sendorder"></index-send-orders>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
          <div style="height: 33.3%">
            <el-row style="height: 100%;">
              <el-col :span="12" class="col-list">
                <div style="height: 50px" v-if="bigScreen"></div>
                <div style="height: 30px" v-else></div>
                <div class="box-item">
                  <div style="height: 1px"></div>
                  <div :class="bigScreen ? 'box-title-big1' : 'box-title1'">
                    <span>今日服务数据</span>
                  </div>
                  <div :class="bigScreen ? 'box-main-big' : 'box-main'">
                    <index-today-service ref="todayservice"></index-today-service>
                  </div>
                </div>
              </el-col>
              <el-col :span="12" class="col-list">
                <div style="height: 50px" v-if="bigScreen"></div>
                <div style="height: 30px" v-else></div>
                <div class="box-item">
                  <div style="height: 1px"></div>
                  <div :class="bigScreen ? 'box-title-big' : 'box-title'">
                    <span>处理列表</span>
                  </div>
                  <div :class="bigScreen ? 'box-main-big' : 'box-main'">
                    <index-handle-list ref="handlelist" v-if="showAlarm" :topObj="topObj"></index-handle-list>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col :span="8" class="col-list">
          <div style="height: 260px;">
            <index-center-top ref="topCenter" :topObj="topObj"></index-center-top>
          </div>
          <div style="height: calc(100% - 385px);">
            <div class="map-div">
              <iframe-map ref="showmap" :mapCenter="mapCenter"></iframe-map>
            </div>
          </div>
          <div style="height: 130px;margin-top: 5px;">
            <index-center-bottom v-if="showSeven" :bottomObj="dataviewcount"></index-center-bottom>
          </div>
        </el-col>
        <el-col :span="8" class="col-list">
          <div style="height: 33.3%">
            <el-row style="height: 100%;">
              <el-col :span="12" class="col-list">
                <div style="height: 50px" v-if="bigScreen"></div>
                <div style="height: 30px" v-else></div>
                <div class="box-item">
                  <div style="height: 1px"></div>
                  <div :class="bigScreen ? 'box-title-big1' : 'box-title1'">
                    <span>区域报警占比</span>
                  </div>
                  <div :class="bigScreen ? 'box-main-big' : 'box-main'">
<!--                    <expense></expense>-->
                    <index-city ref="city" v-if="isFamily" :AlarmCountWithZone="AlarmCountWithZone"></index-city>
                  </div>
                </div>
              </el-col>
              <el-col :span="12" class="col-list">
                <div style="height: 50px" v-if="bigScreen"></div>
                <div style="height: 30px" v-else></div>
                <div class="box-item">
                  <div style="height: 1px"></div>
                  <div :class="bigScreen ? 'box-title-big1' : 'box-title1'">
                    <span>报警类型TOP3</span>
                  </div>
                  <div :class="bigScreen ? 'box-main-big' : 'box-main'">
                    <index-top-three ref="topThree" v-if="isFamily" :AlarmTypeTopThree="AlarmTypeTopThree"></index-top-three>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
          <div style="height: 33.3%">
            <el-row style="height: 100%;">
              <el-col :span="12" class="col-list">
                <div style="height: 50px" v-if="bigScreen"></div>
                <div style="height: 30px" v-else></div>
                <div class="box-item">
                  <div style="height: 1px"></div>
                  <div :class="bigScreen ? 'box-title-big' : 'box-title'">
                    <span>服务资源</span>
                  </div>
                  <div :class="bigScreen ? 'box-main-big' : 'box-main'">
                    <index-service ref="service" v-if="showSeven" :service="dataviewcount"></index-service>
                  </div>
                </div>
              </el-col>
              <el-col :span="12" class="col-list">
                <div style="height: 50px" v-if="bigScreen"></div>
                <div style="height: 30px" v-else></div>
                <div class="box-item">
                  <div style="height: 1px"></div>
                  <div :class="bigScreen ? 'box-title-big' : 'box-title'">
                    <span>报警统计</span>
                  </div>
                  <div :class="bigScreen ? 'box-main-big' : 'box-main'">
                    <alarm-line ref="alarmLine" v-if="isShow" :alarmLine="alarmtype"></alarm-line>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
          <div style="height: 33.3%">
            <el-row style="height: 100%;">
              <el-col :span="12" class="col-list">
                <div style="height: 50px" v-if="bigScreen"></div>
                <div style="height: 30px" v-else></div>
                <div class="box-item">
                  <div style="height: 1px"></div>
                  <div :class="bigScreen ? 'box-title-big1' : 'box-title1'">
                    <span>客服在线人数</span>
                  </div>
                  <div :class="bigScreen ? 'box-main-big' : 'box-main'">
                    <index-customer-online ref="customer"></index-customer-online>
                  </div>
                </div>
              </el-col>
              <el-col :span="12" class="col-list">
                <div style="height: 50px" v-if="bigScreen"></div>
                <div style="height: 30px" v-else></div>
                <div class="box-item">
                  <div style="height: 1px"></div>
                  <div :class="bigScreen ? 'box-title-big' : 'box-title'">
                    <span>服务次数</span>
                  </div>
                  <div :class="bigScreen ? 'box-main-big' : 'box-main'">
                    <index-service-type ref="servicetype"></index-service-type>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import iframeMap from './childComponents/iframeMap'
import alarmLine from './childComponents/alarmLine'
import {getLoad} from '../../api/home'
import {queryorg} from '../../api/organizer'
// 拼接屏
import indexCenterBottom from './bigComponents/indexCenterBottom'
import indexCenterTop from './bigComponents/indexCenterTop'
import indexService from './bigComponents/indexService'
import indexCity from './bigComponents/indexCity'
import indexHandleList from './bigComponents/indexHandleList'
import indexTopThree from './bigComponents/indexTopThree'
import indexNumberService from './bigComponents/indexNumberService'
import indexFamilyDevice from './bigComponents/indexFamilyDevice'
import indexServiceType from './bigComponents/indexServiceType'
import indexSendOrders from './bigComponents/indexSendOrders'
import indexTodayService from './bigComponents/indexTodayService'
import indexCustomerOnline from './bigComponents/indexCustomerOnline'
import indexSendOrder from './bigComponents/indexSendOrder'
import {
  querydataviewcount,
  querydataviewalarm,
  querydataviewtypecount,
  querysosalarmbyaid
} from '../../api/alarmservice'
import {queryoldpersonbypids} from '../../api/handlealarm'
import expense from './bigComponents/expense'

export default {
  name: 'monitor',
  components: {
    expense,
    iframeMap,
    alarmLine,
    indexCenterBottom,
    indexCenterTop,
    indexService,
    indexCity,
    indexHandleList,
    indexTopThree,
    indexNumberService,
    indexFamilyDevice,
    indexServiceType,
    indexSendOrders,
    indexTodayService,
    indexCustomerOnline,
    indexSendOrder},
  data () {
    return {
      isShangHai: true,
      bigScreen: false,
      evenNumber: true,
      isShow: false,
      threeObj: {
        device: 0,
        customerService: 0,
        online: 0
      },
      fourObj: {
        serviceTime: 0,
        serviceTotal: 0,
        todayService: 0,
        oldPeople: 0
      },
      // 设备统计
      devicetype: [],
      alarmtype: [],
      zoneperson: {
        orgData: [],
        person: []
      },
      showSeven: false,
      showAlarm: false,
      topObj: {
        dataviewalarms: [], // 用户信息 处理列表
        dataviewcount: '' // 地图上方数据
      },
      dataviewcount: '', // 服务资源  地图下方四个框
      dataviewalarms: [],
      isMqtt: false,
      alarmObj: '',
      isFamily: false,
      familyDevice: { // 区域用户 家庭&设备总数
        familyDevice: []
      },
      AlarmCountWithZone: [], // 区域报警TOP3 区域报警占比 区域报警
      ServicesCountWithZone: [], // 服务次数
      AlarmTypeTopThree: [], // 报警类型TOP3
      ServicesCountWithTime: [], // 服务人数
      timerLoad: null,
      mapCenter: {
        isJiaOld: true
      }
    }
  },
  created () {
    this.isShangHai = this.$store.state.user.isShangHai
    this.golobleObject.getMqttNewData = this.getMqttNewData1 // mqtt报警过来请求接口更新
    this.golobleObject.updateTableAlarm = this.getMqttNewData2 // mqtt处理报警
    this.evenNumber = this.$store.getters.get_evenNumber
    this.getOrgDate()
    if (this.isShangHai) {
      this.getAreaDeviceData()
      this.getSevenData()
      this.getMqttNewData2() // 初始化接口数据
    }
  },
  mounted () {
    this.timerLoad = setInterval(() => {
      // console.log('刷新')
      this.getTimeRefresh()
    }, 2 * 60 * 1000)
  },
  destroyed () {
    clearInterval(this.timerLoad)
  },
  methods: {
    getTimeRefresh () {
      this.getLoadData()
      this.getAreaDeviceData()
      this.getSevenData()
    },
    getOrgDate () {
      queryorg().then(res => {
        this.getLoadData()
        this.zoneperson.orgData = res.data.org
      }).catch(() => {
        this.getLoadData()
      })
    },
    getLoadData () {
      getLoad().then(res => {
        let obj = res.data
        this.threeObj.device = obj.count.devicecnt
        this.threeObj.customerService = obj.count.sp_cnt
        this.threeObj.device = obj.count.sp_online_cnt
        this.fourObj.serviceTime = obj.count.handle_cnt
        this.fourObj.serviceTotal = obj.count.handle_oldperson_cnt
        this.fourObj.todayService = obj.count.handle_today_cnt
        this.fourObj.oldPeople = obj.count.oldPerson_cnt
        this.devicetype = obj.devicetype
        this.alarmtype = obj.alarmtype // 报警统计
        if (this.isShow) {
          this.$refs.alarmLine.getRefresh(this.alarmtype) // 报警统计
        }
        this.zoneperson.person = obj.zoneperoson
        this.isShow = true
      }).catch(() => {
        this.isShow = true
      })
    },
    // 首頁數據
    getAreaDeviceData () {
      querydataviewtypecount().then(res => {
        this.familyDevice.familyDevice = res.data.dataviewtypecount.FamilyAndDeviceCountWithZone // 区域用户 家庭&设备总数
        this.AlarmCountWithZone = res.data.dataviewtypecount.AlarmCountWithZone // 区域报警TOP3 区域报警占比 区域报警
        this.ServicesCountWithZone = res.data.dataviewtypecount.ServicesCountWithZone // 服务次数
        this.AlarmTypeTopThree = res.data.dataviewtypecount.AlarmTypeTopThree // 报警类型TOP3
        this.ServicesCountWithTime = res.data.dataviewtypecount.ServicesCountWithTime // 服务人数
        this.$refs.customer.getTableData(res.data.dataviewtypecount.CustomerOnlineType) // 客服在线状态
        this.$refs.servicetype.getChartsData(res.data.dataviewtypecount.ServiceTypeCount) // 新的 服务次数
        this.$refs.sendorder.getRefresh(res.data.dataviewtypecount.ServiceTypeTodayCount) // 今日派单次数
        this.$refs.todayservice.getRefresh(res.data.dataviewtypecount.ServiceTypeTodayLevelTwoCount) // 今日服务次数
        this.$refs.indexsendorder.getRefresh(res.data.dataviewtypecount.ServiceTypeCountAndComplete === null ? [] : res.data.dataviewtypecount.ServiceTypeCountAndComplete) // 派单&完成数量
        if (this.isFamily) {
          this.$refs.numberService.getRefresh(this.ServicesCountWithTime) // 服务人数
          this.$refs.familyDevice.getRefresh(this.familyDevice.familyDevice) // 家庭&设备总数
          this.$refs.topThree.getRefresh(this.AlarmTypeTopThree) // 报警类型TOP3
          this.$refs.city.getRefresh(this.AlarmCountWithZone) // 区域报警占比
        }
        this.isFamily = true
        this.$refs.showmap.getRefresh(res.data.dataviewtypecount.FamilyAndDeviceCountWithCommunity) // 地图显示小区数据
      }).catch(() => {})
    },
    // 新页面
    getSevenData () {
      querydataviewcount().then(res => {
        this.dataviewcount = res.data.dataviewcount // 服务资源  地图下方四个框
        this.topObj.dataviewcount = res.data.dataviewcount // 地图上方数据
        this.$refs.topCenter.getAlarmCount(this.topObj)
        this.$refs.customer.getLawyerCount(res.data.dataviewcount.lawercount) // 客服在线状态
        this.$refs.customer.getCustomerCount(res.data.dataviewcount.customeronlinecount) // 客服在线状态
        if (this.showSeven) {
          this.$refs.service.getRefresh(this.dataviewcount)
        }
        this.showSeven = true
      }).catch(() => {
        this.showSeven = true
      })
    },
    // mqtt推送过来请求
    getMqttNewData1 (alarmObj) {
      // console.log('mqtt')
      this.golobleObject.getMqttAddCnt(alarmObj) // 地圖上面 报警总数 加1
      this.isMqtt = true
      this.getMqttNewData(alarmObj)
      this.getMqttByAlarmId(alarmObj)
    },
    // mqtt 获取地图信息
    getMqttByAlarmId (alarmObj) {
      let data = {
        alarmid: alarmObj.alarmid
      }
      querysosalarmbyaid(data).then(res => {
        this.golobleObject.getAlarmMarker(res.data.alarm)
      })
    },
    // 初始化数据
    getMqttNewData2 () {
      this.isMqtt = false
      this.getMqttNewData()
    },
    async getMqttNewData (alarObj) {
      // console.log('mqtt', alarObj)
      querydataviewalarm().then(res => {
        let arr1 = res.data.dataviewalarm.slice(0, 5)
        let arr = []
        let pids = []
        for (let i = 0; i < arr1.length; i++) {
          if (arr1[i].pid !== 0) { // 穿戴设备
            if (pids.indexOf(arr1[i].pid) === -1) {
              pids.push(arr1[i].pid)
            }
          }
        }
        if (pids.length !== 0) {
          this.getPhotoUrl(pids).then((data) => {
            let person = data
            for (let i = 0; i < arr1.length; i++) {
              let obj = arr1[i]
              obj.alarObj = ''
              obj.person = ''
              if (alarObj) {
                if (alarObj.alarmid === arr1[i].id) {
                  obj.alarObj = alarObj
                }
              }
              for (let j = 0; j < person.length; j++) {
                if (arr1[i].pid === person[j].id) {
                  obj.person = person[j]
                }
              }
              arr.push(obj)
            }
            this.getSendData(arr)
          })
        } else {
          this.getSendData(arr1)
        }
        this.showAlarm = true
      }).catch(() => {
        this.showAlarm = true
      })
    },
    getSendData (arr) {
      this.topObj.dataviewalarms = arr // 用户信息 处理列表
      if (this.showAlarm) {
        this.$refs.handlelist.getListData(arr) // 处理列表
      }
      // console.log('图片', arr[0])
      this.dataviewalarms = arr
      // 地圖
      if (this.isMqtt) {
        // this.golobleObject.getAlarmMarker(arr[0])
      }
      // 地圖上方的三框
      this.golobleObject.getNewAlarm(this.dataviewalarms)
    },
    async getPhotoUrl (pids) {
      let arr = []
      let data = {
        pids: pids
      }
      await queryoldpersonbypids(data).then(res => {
        arr = res.data.persons
      }).catch(() => {})
      return arr
    }
  }
}
</script>

<style scoped>
  .map-div{
    width: 100%;
    height: 100%;
  }
  .col-list{
    height: 100%;
  }
  .box-item{
    margin: 0 10px;
    height: calc(100% - 30px);
    background: url("../../assets/SHscreen/index_bg_box.png") no-repeat;
    background-size: 100% 100%;
  }
  .box-item-big{
    margin: 0 10px;
    height: calc(100% - 50px);
    background: url("../../assets/SHscreen/index_bg_box.png") no-repeat;
    background-size: 100% 100%;
  }
  .box-title{
    width: 170px;
    margin: -15px auto 0;
    height: 30px;
    line-height: 30px;
    font-size: 15px;
    text-align: center;
    color: white;
    background: url("../../assets/SHscreen/index_bg_box_title.png") no-repeat;
    background-size: 100% 100%;
  }
  .box-title-big{
    width: 300px;
    margin: -30px auto 0;
    height: 60px;
    line-height: 60px;
    font-size: 30px;
    text-align: center;
    color: white;
    background: url("../../assets/SHscreen/index_bg_box_title1.png") no-repeat;
    background-size: 100% 100%;
  }
  .box-title1{
    width: 170px;
    margin: -15px auto 0;
    height: 30px;
    line-height: 30px;
    font-size: 15px;
    text-align: center;
    color: white;
    background: url("../../assets/SHscreen/index_bg_box_title1.png") no-repeat;
    background-size: 100% 100%;
  }
  .box-title-big1{
    width: 300px;
    margin: -30px auto 0;
    height: 60px;
    line-height: 60px;
    font-size: 30px;
    text-align: center;
    color: white;
    background: url("../../assets/SHscreen/index_bg_box_title.png") no-repeat;
    background-size: 100% 100%;
  }
  .box-main{
    height: calc(100% - 15px);
    /*background-color: yellow;*/
  }
  .box-main-big{
    height: calc(100% - 30px);
    /*background-color: yellow;*/
  }
</style>



// WEBPACK FOOTER //
// src/components/monitoring/defaultPage.vue